import * as React from "react"
import { Box } from "@mui/material"
import {useProductPageDetailsReportForm} from "../../@hooks";
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useProductPageDetailsReportForm()

    return <Box componet="span" data-tour="pp-details-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}